<template>
  <v-card class="mt-4 rounded-card card-shadow" v-if="itensCompra && itensCompra.length">
    <v-card-title class="title font-weight-bold">
      Entregas
    </v-card-title>
    <v-card-text class="text--primary">
      <px-entrega-produtos-compras-item v-for="(item, index) in itensCompra"
                                        outlined
                                        :compra-produto="item"
                                        :key="`item-${index}`"/>
    </v-card-text>
  </v-card>
</template>

<script>
import FinalizacaoService from '@/modules/finalizacao/finalizacao-service';
import EntregaProdutosComprasItem
from '@/modules/finalizacao/entregas/EntregaProdutosComprasItem.vue';

export default {
  props: {
    compraId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      itensCompra: [],
    };
  },
  methods: {
    getSaldosEntregas() {
      FinalizacaoService.getSaldosEntregas(this.compraId)
        .then(({ data }) => {
          this.itensCompra = data;
        });
    },
  },
  created() {
    this.getSaldosEntregas();
  },
  components: {
    pxEntregaProdutosComprasItem: EntregaProdutosComprasItem,
  },
};
</script>
